<div class="screen-container">
	<div class="failed-container">
		<div>
			<p class="title-xs text-center font-serra">Echec du paiement</p>
			<img class="card-img" src="img/skin/payment-failed.svg"/>
			<div class="action-container">
				<a href="#" [routerLink]="router.get('plan-checkout')" class="btn bg-white text-primary border-[#e5e5e5] mb-2">
					Essayez à nouveau
				</a>
			</div>
		</div>
	</div>
</div>